/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Trail_EmptyInputs */

const en_automation_trail_empty = /** @type {(inputs: Automation_Trail_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No automation has run on this case yet.`)
};

const pt_br2_automation_trail_empty = /** @type {(inputs: Automation_Trail_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma automação foi executada neste caso ainda.`)
};

/**
* | output |
* | --- |
* | "No automation has run on this case yet." |
*
* @param {Automation_Trail_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trail_empty = /** @type {((inputs?: Automation_Trail_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trail_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trail_empty(inputs)
	return pt_br2_automation_trail_empty(inputs)
});